export default __webpack_public_path__ + "static/media/nutrition.05e5bf4e.png";